<!--  -->
<template>
  <div style="max-width: 100vw!important;">
    <div class="w-header" v-if="isPc()" style="margin-bottom: 5rem;">
      <div class="w-header-content-wrapper">
        <div data-animation="default" data-collapse="medium" data-duration="400" data-easing="ease" data-easing2="ease" role="banner" class="w-navbar w-nav">
          <Header activeMenuIndex="1"></Header>
        </div>
      </div>
    </div>
    <div class="header" v-if="!isPc()">
      <div class="w-header-content-wrapper">
        <div data-animation="default" data-collapse="medium" data-duration="400" data-easing="ease" data-easing2="ease" role="banner" class="w-navbar w-nav">
          <userHeader></userHeader>
        </div>
      </div>
    </div>
    <section>
      <img class="banner-image" :src="require(`@/assets/img/ranking/rankingHeader.jpg`)" style="width: 100vw" alt="banner">
      <Votes />
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
import { isPc } from "@/utils/common";
import Header from "@/components/header.vue";
import userHeader from "@/components/mobile/userHeader.vue";
import Banner from "@/components/banner-img.vue";
import Footer from "../../components/footer.vue";
import request from "@/services/request";
import Votes from "./votes.vue";
export default {
  data() {
    return {
      tokens: [
        {
            "name": "GSC公链",
            "symbol": "GSC",
            "totalVotes": 0,
        },
        {
            "name": "OORT公链",
            "symbol": "OORT",
            "totalVotes": 0,
        },
        {
            "name": "CFX公链",
            "symbol": "CFX",
            "totalVotes": 0,
        },
        {
            "name": "BTY公链",
            "symbol": "BTY",
            "totalVotes": 0,
        }
      ],
      user: null,
      lang: "",
      symbol: ""
    };
  },
  created() {
    this.lang = sessionStorage.getItem("Language");
  },
  methods: {
    isPc,
  },
  components: {
    Header,
    Banner,
    Footer,
    Votes,
    userHeader
  },
};
</script>